import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hometwo-services',
  templateUrl: './hometwo-services.component.html',
  styleUrls: ['./hometwo-services.component.scss']
})
export class HometwoServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
